import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';

import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';

import CopySignerLink from './copy-signer-link';

// ----------------------------------------------------------------------
// TESTING/STAGING ONLY — see copy-signer-link.tsx. Remove before production.
// ----------------------------------------------------------------------

interface SignerLike {
  id: string;
  first_name: string;
  last_name: string;
  access_token?: string | null;
}

interface Props {
  signers: SignerLike[];
}

export default function SignerLinksMenu({ signers }: Props) {
  const popover = usePopover();

  const withTokens = signers.filter((s) => !!s.access_token);
  if (!withTokens.length) return null;

  return (
    <>
      <Button size="small" startIcon={<Iconify icon="solar:link-bold" />} onClick={popover.onOpen}>
        Links
      </Button>
      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 380 }}>
        <Box sx={{ p: 2 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Signer links (testing)
          </Typography>
          <Stack spacing={1.5}>
            {withTokens.map((s) => (
              <CopySignerLink key={s.id} token={s.access_token!} name={`${s.first_name} ${s.last_name}`} />
            ))}
          </Stack>
        </Box>
      </CustomPopover>
    </>
  );
}
